import React from 'react';
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid, Legend } from 'recharts';
import { Card } from '@/components/ui/card';

const fmtDay = (d) => `${d.slice(8, 10)}/${d.slice(5, 7)}`;

export const GestionDailyChart = ({ daily }) => (
  <Card className="p-5 border-slate-200 bg-white" data-testid="gestion-daily-chart">
    <h4 className="font-semibold text-slate-900 text-sm mb-3">Gestiones por día</h4>
    <div className="h-56">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={daily} margin={{ top: 4, right: 8, left: -20, bottom: 0 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" vertical={false} />
          <XAxis dataKey="date" tickFormatter={fmtDay} tick={{ fontSize: 11, fill: '#64748b' }} interval="preserveStartEnd" minTickGap={24} />
          <YAxis allowDecimals={false} tick={{ fontSize: 11, fill: '#64748b' }} />
          <Tooltip labelFormatter={fmtDay} formatter={(v, name) => [v, name === 'total' ? 'Gestiones' : 'Positivas']} contentStyle={{ fontSize: 12, borderRadius: 8 }} />
          <Legend formatter={(v) => (v === 'total' ? 'Gestiones' : 'Contactos positivos')} wrapperStyle={{ fontSize: 12 }} />
          <Bar dataKey="total" fill="#0f172a" radius={[3, 3, 0, 0]} />
          <Bar dataKey="positives" fill="#0d9488" radius={[3, 3, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  </Card>
);

export const GestionResponses = ({ responses }) => {
  const total = responses.reduce((a, r) => a + r.count, 0);
  return (
    <Card className="p-5 border-slate-200 bg-white" data-testid="gestion-responses">
      <h4 className="font-semibold text-slate-900 text-sm mb-3">Resultados de las gestiones</h4>
      {responses.length === 0 ? <p className="text-sm text-slate-400 text-center py-6">Sin respuestas registradas en el período.</p> : (
        <ul className="space-y-2">
          {responses.map((r) => (
            <li key={r.id} data-testid={`gestion-response-${r.id}`}>
              <div className="flex items-center justify-between text-xs mb-1">
                <span className="inline-flex items-center gap-1.5 font-medium text-slate-700">
                  <span className="w-2 h-2 rounded-full" style={{ backgroundColor: r.color || '#64748b' }} />{r.name}
                  {r.is_positive && <span className="text-[10px] text-teal-700 bg-teal-50 rounded px-1">positiva</span>}
                </span>
                <span className="text-slate-500">{r.count} · {total ? Math.round((r.count / total) * 100) : 0}%</span>
              </div>
              <div className="h-1.5 rounded-full bg-slate-100 overflow-hidden"><div className="h-full rounded-full" style={{ width: `${total ? (r.count / total) * 100 : 0}%`, backgroundColor: r.color || '#64748b' }} /></div>
            </li>
          ))}
        </ul>
      )}
    </Card>
  );
};
